/* eslint-disable react/no-this-in-sfc */
/* eslint-disable react/destructuring-assignment */
import React, {useEffect, useState} from 'react';

import {batch, useDispatch, useSelector} from 'react-redux';

import * as loadingActions from '@/actions/loadingActions';
import * as modalActions from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
import {Get, Post} from '@/api/request';
import SetupIcon from '@/assets/icons/ant-design_setting-outlined.svg';
import CleaningIcon from '@/assets/icons/charm_flag.svg';
import FinishIcon from '@/assets/icons/mdi_timer-sand.svg';
// import CleaningWizardComponent from '@/components/wizard/Wizard';
import Wizard from '@/components/wizard/WizardComponent';
import {DEFAULT_CLEANING_TYPE} from '@/constants/calibrationWizardConstant';
import {PRESSURE_RUN_TOO_LONG_MESSAGE} from '@/constants/messages';
import * as APPDATA from '@/constants/pcConstAppData';
import {consoleLog} from '@/libs/consoleHelper';

import {INITIAL_CUSTOM_OPERATION} from '../../stores/reducers/setupStore';

import CompleteWizard from './cleaningWizard/CompleteWizard';
import SelectDuration from './cleaningWizard/SelectDuration';
import StatusWizard from './cleaningWizard/StatusWizard';

import style from './CleaningWizard.less';

function CleaningWizard() {
  const dispatch = useDispatch();
  const setupStore = useSelector((state) => state.setupStore);
  const {cleaningCustomOperation, nextActionWizard, cleaningProperties, prevActionWizard, failureMessage} = setupStore;
  const {MembraneCutOffSize, cleaningDuration} = cleaningProperties;

  const [activeStep, setActiveStep] = useState(0);
  const [triggerStopCleaning, setTriggerStopCleaning] = useState(false);
  const [isStopClicked, setIsStopClicked] = useState(false);

  const resetCleaningProperties = {
    isCleaningWizardRunning: false,
    cleaningDuration: undefined,
    cleaningSolution: 25,
    valveChipType: 6,
    [APPDATA.KEY.MembraneCutOffSize]: undefined,
  };

  const COMPLETE_CLEANING_STEP = [
    {
      title: 'SETUP',
      icon: SetupIcon,
      content: <SelectDuration />,
    },
    {
      title: 'CLEANING',
      icon: CleaningIcon,
      content: <StatusWizard />,
    },
    {
      title: 'FINISH',
      icon: FinishIcon,
      content: <CompleteWizard />,
    },
  ];

  useEffect(() => {
    dispatch(setupActions.updateActiveMenu(APPDATA.CLEANING_WIZARD));
    setActiveStep(0);
    setupTopMenuProperties();
  }, []);

  useEffect(() => {
    if (nextActionWizard && !isStopClicked) {
      setActiveStep(activeStep + 1);
    }
  }, [nextActionWizard, isStopClicked]);

  useEffect(() => {
    if (prevActionWizard) {
      setActiveStep(activeStep > 0 ? activeStep - 1 : 0);
      dispatch(setupActions.prevActionWizard(false));
    }
  }, [prevActionWizard]);

  useEffect(() => {}, [cleaningProperties]);

  useEffect(() => {
    if (activeStep === 2) {
      setupTopMenuOnFinish();
    }
  }, [activeStep]);

  useEffect(() => {
    if (triggerStopCleaning) {
      setIsStopClicked(false);
      dispatch(setupActions.nextActionWizard(false));
      setActiveStep(0);
      dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: APPDATA.MESSAGES.CLEANING_WIZARD.STOPPED_CLEANING_CYCLE,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        }),
      );
      setTriggerStopCleaning(false);
      dispatch(loadingActions.showLoading(false));
      dispatch(setupActions.setCleaningProperties(resetCleaningProperties));
      setupTopMenuProperties();
    }
  }, [cleaningCustomOperation.Status, triggerStopCleaning]);

  useEffect(() => {
    if (MembraneCutOffSize === undefined || cleaningDuration === undefined) {
      setupTopMenuProperties(true);
    } else {
      setupTopMenuProperties(false);
    }
  }, [MembraneCutOffSize, cleaningDuration]);

  useEffect(() => {
    if (failureMessage === PRESSURE_RUN_TOO_LONG_MESSAGE) {
      setupTopMenuProperties();
    }
  }, [failureMessage]);

  const setupTopMenuOnFinish = () => {
    const topButtonProperties = undefined;
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: true,
      onClick: cleaningWizardBackAction,
    };
    const titleMenuProperties = APPDATA.CLEANING_WIZARD;
    setTopMenuProperties(topButtonProperties, backButtonProperties, titleMenuProperties);

    dispatch(modalActions.hidePopUp());
  };

  // const generateView = () => <CleaningWizardComponent nextActionCallback={nextActionCallbackWizard} />;

  const setupTopMenuProperties = (disabled = true) => {
    const topButtonProperties = {
      id: APPDATA.RUN,
      label: APPDATA.RUN,
      onClick,
      disabled,
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: cleaningWizardBackAction,
    };
    const titleMenuProperties = APPDATA.CLEANING_WIZARD;
    setTopMenuProperties(topButtonProperties, backButtonProperties, titleMenuProperties);
  };

  const onClick = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.RUN: {
        const param = {
          CleaningType: DEFAULT_CLEANING_TYPE,
          CleaningDuration: cleaningProperties.cleaningDuration.toString(),
          MembraneCutOffSize: cleaningProperties[APPDATA.KEY.MembraneCutOffSize].toString(),
        };
        let variabel;
        Post(
          APPDATA.API.POST_START_CLEANIG_WIZARD,
          param,
          successStartCleaningWizard,
          variabel,
          failedStartCleaningWizard,
        );
        break;
      }
      case APPDATA.STOP:
        Get(APPDATA.API.GET_STATUS_CLEANING_WIZARD, '', statusOfCleaningWizardStop);
        break;
      case APPDATA.BACK: {
        const statusOfCleaningWizard = null;
        if (this.state.activeWizardStepId === this.state.stepWizard.length - 1)
          Get(APPDATA.API.GET_STATUS_CLEANING_WIZARD, '', statusOfCleaningWizard);
        else dispatch(setupActions.prevActionWizard(true));
        break;
      }
      case APPDATA.EXIT:
        setActiveStep(0);
        backToHomePage();
        break;
      default:
        break;
    }
  };

  const statusOfCleaningWizardStop = (response) => {
    const status = response.data.Status;

    switch (status) {
      case APPDATA.DEVICE_STATE.IDLE:
        selectModeTopMenuProperties();
        break;
      case APPDATA.DEVICE_STATE.RUNNING:
      case APPDATA.DEVICE_STATE.PREPARING: {
        const popUpButton = [
          {
            id: APPDATA.CANCEL,
            isPrimaryButton: true,
            onClick: onClickStopButton,
            label: APPDATA.CANCEL,
            disabled: false,
          },
          {
            id: APPDATA.STOP,
            isPrimaryButton: false,
            onClick: onClickStopButton,
            label: APPDATA.STOP,
          },
        ];
        dispatch(
          modalActions.showPopUp({
            popUpTitle: APPDATA.CLEANING_WIZARD,
            popUpText: APPDATA.MESSAGES.CLEANING_WIZARD.STOP_OR_CONTINUE_WIZARD,
            popUpButton,
          }),
        );
        break;
      }
      default:
        break;
    }
  };

  const onClickStopButton = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.STOP: {
        setIsStopClicked(true);
        ShowDepressurizingModalDialog();
        const param = {};
        let variabel;
        Post(
          APPDATA.API.POST_STOP_CLEANIG_WIZARD,
          param,
          successStopCleaningWizard,
          variabel,
          failedStopCleaningWizard,
        );
        break;
      }
      case APPDATA.CANCEL:
        break;
      default:
        break;
    }
    dispatch(modalActions.hidePopUp());
  };

  const successStopCleaningWizard = () => {
    setTriggerStopCleaning(true);
  };

  const ShowDepressurizingModalDialog = () => {
    dispatch(
      loadingActions.updateLoading({
        showLoading: true,
        loadingText: APPDATA.MESSAGES.CYCLE_PROCESS.DEPRESSURIZING,
        // loadingButton1: {
        //   label: APPDATA.CLOSE,
        //   onClick: () => backToHomePage()
        // }
      }),
    );
  };

  const selectModeTopMenuProperties = () => {
    const topButtonProperties = {
      id: APPDATA.RUN,
      label: APPDATA.RUN,
      onClick,
      disabled: false,
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: cleaningWizardBackAction,
    };
    const titleMenuProperties = APPDATA.CLEANING_WIZARD;
    setTopMenuProperties(topButtonProperties, backButtonProperties, titleMenuProperties);
  };

  const successStartCleaningWizard = () => {
    const tempCleaningProperties = {...cleaningProperties};
    tempCleaningProperties.isCleaningWizardRunning = true;
    setActiveStep(1);

    dispatch(setupActions.setCleaningProperties(tempCleaningProperties));
    dispatch(
      setupActions.topButtonProperties({
        id: APPDATA.STOP,
        label: APPDATA.STOP.toUpperCase(),
        onClick,
        disabled: false,
      }),
    );
    dispatch(
      setupActions.backButtonProperties({
        id: APPDATA.BACK,
        label: '',
        disabled: true,
        onClick,
      }),
    );
  };

  const failedStartCleaningWizard = (error) => {
    const textMsg = error.response === undefined ? error.message : error.response.data.message;
    dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: textMsg,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
      }),
    );
  };

  const failedStopCleaningWizard = () => {
    setIsStopClicked(false);
  };

  const cleaningWizardBackAction = () => {
    consoleLog('cleaningWizardBackAction');
    backToHomePage();
  };

  const backToHomePage = () => {
    consoleLog('backToHomePage');
    batch(() => {
      dispatch(loadingActions.showLoading(false));
      // need to reset the current store value for Custom Operation
      dispatch(setupActions.SetCleaningCustomOperation(INITIAL_CUSTOM_OPERATION));
      dispatch(setupActions.setCleaningProperties(resetCleaningProperties));
      window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
    });
  };

  const setTopMenuProperties = (topButtonProperties, backButtonProperties, titleMenuProperties) => {
    dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
      }),
    );
    dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  return (
    <div style={style.constraint}>
      {/* {generateView()} */}
      {/* asdasdsadsdasd */}
      {/* <CleaningWizardComponent nextActionCallback={nextActionCallbackWizard} /> */}
      <Wizard
        step={COMPLETE_CLEANING_STEP}
        activeStep={activeStep}
      />
    </div>
  );
}

export default CleaningWizard;
